import { createLucideIcon } from 'lucide-react';

const SaudiRiyal = createLucideIcon('SaudiRiyal', [
  ['path', { d: 'm20 19.5-5.5 1.2', key: '1' }],
  ['path', { d: 'm14.5 4v11.22a1 1 0 0 0 1.242.97L20 15.2', key: '2' }],
  ['path', { d: 'M2.978 19.351l5.549-1.363A2 2 0 0 0 10 16V2', key: '3' }],
  ['path', { d: 'm20 10-16 3.5', key: '4' }],
]);

export default SaudiRiyal;

